module.exports = __webpack_public_path__ + "static/img/tool.7eeca74a.jpg";